import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateAdminStudioBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const updateAdminStudio = createAsyncThunk<void, UpdateAdminStudioBody, { extra: Partial<Dependencies> }>(
  "admin/studio/update",
  async (body, { extra: { adminRepository } }) => {
    await adminRepository!.updateStudio(body);
  },
);
